import { render, staticRenderFns } from "./CourseTeacher.vue?vue&type=template&id=71325b10&"
import script from "./CourseTeacher.vue?vue&type=script&lang=js&"
export * from "./CourseTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports